import styled from "@emotion/styled";
import { surface, spacing, fontSize, fontWeight, dataViz, layout } from "@atlas-int/tokens";

export const gridLines = {
  titleHeaderTop: "TitleHeaderTop",
  titleHeaderBottom: "TitleHeaderBottom",
  visualizationContentTop: "VisualizationContentTop",
  visualizationContentBottom: "VisualizationContentBottom",
  intraRegionTradeDisclaimerTop: "IntraRegionTradeDisclaimerTop",
  intraRegionTradeDisclaimerBottom: "IntraRegionTradeDisclaimerBottom",
  visualizationHandlesTop: "VisualizationHandlesTop",
  visualizationHandlesBottom: "VisualizationHandlesBottom",
  visualizationAreaLeft: "VisualizationAreaLeft",
  visualizationAreaRight: "VisualizationAreaRight",
  visualizationControlsTop: "VisualizationControlsTop",
  visualizationControlsBottom: "VisualizationControlsBottom",
};

export const gridAreas = {
  visualization: "VisualizationArea",
  controls: "ControlsArea",
  visualizationTitle: "VisualizationTitleArea",
  visualizationContent: "VisualizationContentArea",
  intraRegionTradeDisclaimer: "IntraRegionTradeDisclaimer",
  visualizationBottomRow: "VisualizationBottomRowArea",
  visualizationHandles: "VisualizationHandlesArea",
  visualizationTotal: "VisualizationTotalArea",
};

export const VisualizationTitleContainer = styled.div`
  grid-area: ${gridAreas.visualizationTitle};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1 0 auto;
  min-height: 50px;
  padding: ${spacing[0]} ${layout.vizPadding};
`;

export const VisualizationTitleBase = styled.div`
  padding: ${spacing[1]} ${spacing[4]};
  font-weight: ${fontWeight.semibold};
  font-size: ${fontSize["2xl"]};
`;

export const IntraRegionTradeDisclaimerContainer = styled.div`
  grid-area: ${gridAreas.intraRegionTradeDisclaimer};
  padding-top: ${spacing[4]};
  padding-bottom: ${spacing[12]};
  margin-bottom: ${spacing[12]};
  text-align: right;
  color: ${dataViz.textSecondary};
  font-size: ${fontSize.xs};
`;

export const VisualizationGrid = styled.div`
  grid-area: ${gridAreas.visualization};
  display: grid;
  box-sizing: border-box;
  padding: ${spacing[0]} ${layout.vizPadding};

  grid-template-rows: [ ${gridLines.visualizationContentTop}] minmax(0, 1fr) [ ${gridLines.visualizationContentBottom} ${gridLines.visualizationHandlesTop}] auto [ ${gridLines.visualizationHandlesBottom}];
  grid-template-columns: [ ${gridLines.visualizationAreaLeft}] 1fr [ ${gridLines.visualizationAreaRight}];
  grid-template-areas:
    "${gridAreas.visualizationContent}"
    "${gridAreas.visualizationBottomRow}";
`;

export const VisualizationContentContainer = styled.div`
  grid-area: ${gridAreas.visualizationContent};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: ${spacing[4]} ${spacing[0]} ${spacing[10]} ${spacing[0]};
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  height: 100%;
  flex-shrink: 1;
  flex-direction: column;
`;

export const VisualizationBottomRowContainer = styled.div`
  grid-area: ${gridAreas.visualizationBottomRow};
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-bottom: ${spacing[4]};
`;

export const VisualizationHandlesContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const VisualizationTotalContainer = styled.div`
  flex: 0 1 auto;
  height: 100%;
  background-color: ${surface.muted};
  text-transform: uppercase;
  font-size: ${fontSize.lg};
  padding: ${spacing[4]};
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

export const TotalValueLabel = styled.span`
  font-size: ${fontSize["3xl"]};
  font-weight: ${fontWeight.bold};
  margin-left: ${spacing[4]};
`;
